export const truncateParagraph = (string: string, numChars: number) => {
  let current = string[numChars];
  while (current && numChars > 0 && current !== ' ') {
    numChars -= 1;
    current = string[numChars];
  }
  return string.slice(0, numChars);
};

export function titleCase(string: string) {
  return string
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .split(' ')
    .map((word: string) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
}

export function firstWordUppercase(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function toCamelCase(string: string) {
  return string
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .split(' ')
    .map((word: string) => word[0].toUpperCase() + word.slice(1))
    .join('');
}

export function toPlural(
  string: string,
  count: number,
  pluralString = 's',
): string {
  if (count === 1) {
    return string;
  }
  return string + pluralString;
}

export function formatScore(score: number) {
  return (score / 10).toFixed(1);
}

export function convertToInt(string: string) {
  return Number.parseInt(string?.replace(/,/g, ''));
}

export function convertToFloat(string: string) {
  return Number.parseFloat(string?.replace(/,/g, ''));
}

export function noData() {
  return '\u2014';
}
